import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Archive, Trophy, Users, Calendar, ArrowRight } from 'lucide-react';
import { edizioniPassate as edizioniMock } from '../data/mock';
import { api } from '../api/client';
import SocialShare from '../components/SocialShare';
import { useSiteText } from '../hooks/useSiteText';

export default function EdizioniPassate() {
  const [edizioniPassate, setEdizioniPassate] = useState(edizioniMock);
  const title = useSiteText('edizioni.title', 'Edizioni Passate');
  const subtitle = useSiteText('edizioni.subtitle', 'Rivivi le edizioni precedenti del Memorial Eugenio Abbro. Ogni anno, una storia di sport, passione e ricordi.');
  const scopriBtn = useSiteText('edizioni.scopri_btn', 'Scopri');
  useEffect(() => {
    let alive = true;
    api.getEditions().then((rows) => {
      if (alive && Array.isArray(rows) && rows.length > 0) setEdizioniPassate(rows);
    }).catch(() => { /* fallback su mock */ });
    return () => { alive = false; };
  }, []);

  return (
    <div className="bg-navy min-h-screen">
      <section className="relative py-24">
        <div className="absolute inset-0 bg-gradient-to-b from-navy-dark to-navy"></div>
        <div className="relative max-w-5xl mx-auto px-4 lg:px-8 text-center">
          <Archive size={48} className="text-pink-brand mx-auto mb-4" />
          <h1 className="font-brand text-5xl md:text-6xl font-bold text-white mb-4">{title}</h1>
          <div className="w-24 h-1 bg-pink-brand mx-auto rounded"></div>
          <p className="text-white/70 mt-6 max-w-2xl mx-auto">
            {subtitle}
          </p>
          <div className="mt-6 flex justify-center">
            <SocialShare title="Edizioni Passate — Memorial Eugenio Abbro" />
          </div>
        </div>
      </section>

      <section className="pb-20">
        <div className="max-w-6xl mx-auto px-4 lg:px-8">
          <div className="grid md:grid-cols-2 gap-6">
            {edizioniPassate.map((ed) => (
              <Link
                key={ed.anno}
                to={`/edizioni-passate/${ed.anno}`}
                className="group glass-card overflow-hidden block"
              >
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={ed.copertina}
                    alt={ed.edizione}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-navy-dark via-navy-dark/40 to-transparent"></div>
                  <div className="absolute top-4 left-4 bg-pink-brand text-white font-bold text-3xl px-4 py-2 rounded-lg">
                    {ed.anno}
                  </div>
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-2 text-pink-brand text-xs font-bold uppercase tracking-widest mb-2">
                    <Calendar size={12} /> {ed.date}
                  </div>
                  <h3 className="text-white font-bold text-xl mb-3">{ed.edizione}</h3>
                  <p className="text-white/70 text-sm mb-4 line-clamp-2">{ed.descrizione}</p>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-4 border-t border-white/10">
                    {ed.vincitoriCategorie.map((v, i) => (
                      <div key={i} className="flex items-start gap-2">
                        <Trophy size={16} className="text-pink-brand flex-shrink-0 mt-0.5" />
                        <div>
                          <div className="text-white/50 text-[10px] uppercase font-bold">{v.categoria}</div>
                          <div className="text-white text-xs font-semibold leading-tight">{v.vincitore}</div>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="mt-5 flex items-center justify-between">
                    <div className="flex items-center gap-2 text-white/80 text-sm">
                      <Users size={14} /> {ed.squadrePartecipanti} squadre
                    </div>
                    <div className="inline-flex items-center gap-2 text-pink-brand font-bold text-sm group-hover:gap-3 transition-all">
                      {scopriBtn} <ArrowRight size={16} />
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
